"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUEST_STATUS = void 0;
exports.GUEST_STATUS = {
    DELETED: 'DELETED',
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
};
